/*jshint esversion: 6 */
(function () {
  class ReelSpinnerVisualGigablox extends SlotsEngine.types.ReelSpinnerVisual {
    constructor(reelId, name, maxAppertureHeight, slotMach, minSpacing, blockSize, gigabloxFactory, reelIndex) {
      const pre = Globals.NUM_PRE_APPERATURE_SYMBOLS; // i want this to be 7 - but it breaks, need to figure out why
      // set const preApp = 7; to the same number in buildGigabloxData in yggservergame.js
      // still not right when it comes to the pop
      const post = Globals.NUM_POST_APPERATURE_SYMBOLS;
      // pass in true at the end as we want ReelSpinnerCascadeData.js
      super(reelId, name, maxAppertureHeight, slotMach, minSpacing, blockSize, pre, post, false, undefined, false);
      this._blockSize = blockSize;
      this._gigabloxFactory = gigabloxFactory;
      this._symbolSizes = [];
      this._reelIndex = reelIndex;
      this.initialiseSymbolSizes(resourceManager.configuration['symbols_' + this._blockSize + 'x' + this._blockSize]);

      this._symbolMovieName += '_' + blockSize + 'x' + blockSize;
      this._symbolMovieDescriptors += '_' + blockSize + 'x' + blockSize;
      this._blockData = [];
      let self = this;
      slotMach.subscribeToNewSymbolEvent(function (reelId, symbolId) {
        if (reelId === self._reelSpinnerData._reelId) {
          // we need to assign the new symbols to the gfxTextures because
          // we get notified of a new symbol before we have updated the textures
          //so if we are looking at things like texture width they point to the old symbol not new one
          self.redraw();
        }
      });

      /* slotMach.subscribeToSpinAbortedEvent(function(){
                      self.redraw();                        
                    })*/

      slotMach.subscribeToSymbolChangedEvent(function (reelId) {
        if (isNaN(reelId)) {
          alert('an error has occurred');
          console.log('subscribeToSymbolChangedEvent received both number and string as type');
        }
        if (reelId === self._reelIndex) {
          self.redraw();
        }
      });

      slotMach.subscribeToReelsLandedEvent(function (reelId) {
        if (reelId === self._reelSpinnerData._reelId) {
          self.redraw();
        }
      });

      this.bonusSymbolPolyData = [
        null, //
        [22, 22, 37, 22, 85, 0, 132, 22, 148, 22, 148, 170, 22, 170],
        [0, 22, 15, 22, 62, 0, 110, 22, 140, 22, 188, 0, 236, 22, 252, 22, 252, 170, 0, 170],
        [0, 22, 15, 22, 62, 0, 110, 22, 140, 22, 188, 0, 236, 22, 266, 22, 315, 0, 378, 22, 378, 170, 0, 170],
      ];

      this.wasSpinningBefore = false;
      this.hitAreasRequired = true;
      this.canClickASymbol = false;

      Reflex.registerEventHandler('orientationChange', this.onOrientationChange.bind(this));
    }

    disableSymbolHitAreas() {
      this.canClickASymbol = false;
    }

    enableSymbolHitAreas() {
      this.canClickASymbol = true;
    }

    onSymbolTouched(symbolTouched, symbolIndex) {
      const x = symbolTouched.symbol.x;
      const y = symbolTouched.symbol.y;
      const symId = this._reelSpinnerData._symbolData[symbolIndex].symId;
      const data = { x: x, y: y, symId: symId, symbolIndex: symbolIndex, symbolTouched: symbolTouched, reel: this };
      // const data = { x: x, y: y, symId: symId, symbolIndex: symbolIndex, reel: this };
      // console.log('onSymbolTouched', data);
      messageBus.postImmediate('game:symbolTouched', data);
    }

    redraw(recalcBlockData = true) {
      this.hitAreasRequired = true;
      this.updateSymbols();
      this.scaleToImageSize();
      if (this._blockSize > 1) {
        this.updateClipRects(recalcBlockData);
      }
    }

    // incase symbols are different size canvases like glows etc
    initialiseSymbolSizes(symbolData) {
      this._symbolSizes = new Array(Object.keys(symbolData).length).fill({ x: 0, y: 0 });
      for (let prop in symbolData) {
        if (symbolData.hasOwnProperty(prop) && symbolData[prop].imageSize) {
          let data = symbolData[prop];
          this._symbolSizes[Number(data.ID)] = data.imageSize;
        }
      }

      if (this._symbolGfxObjects.length > 0) {
        this.scaleAllToImageSize();
      }
    }

    onOrientationChange() {
      this.scaleToImageSize();
    }

    scaleIndexToImageSize(index) {
      const symbolData = this._reelSpinnerData.getSymbolData();
      const symId = symbolData[index].symId;
      const width = this._symbolGfxObjects[index].symbol.texture.width;
      const height = this._symbolGfxObjects[index].symbol.texture.height;
      const x = this._symbolSizes[symId].x / width;
      const y = this._symbolSizes[symId].y / height;
      this._symbolGfxObjects[index].scale.set(x, y);
    }

    scaleToImageSize() {
      for (let i = 0; i < this._symbolGfxObjects.length; ++i) {
        this.scaleIndexToImageSize(i);
      }
    }

    // for over hanging symbols etc
    initialiseSymbolOffsets() {
      let blockSize = this._reelSpinnerData._reservedSpace;
      super.initialiseSymbolOffsets(resourceManager.configuration['symbols_' + blockSize + 'x' + blockSize]);
    }

    // we dont render one big gigablox symbol. We actual render a clipped section of it. Despite how many symbols are
    // in view for this particular reel the reel itself will still be made up of 5 rows (standard gigablox layout is 5x5).
    // so if there is a 3x3 symbol in view at the top of the window, row 0 will show the top third of the symbol, row 1 middle third,
    // row 2 bottom third. This is done via cliprects. The reason for this is the ReelSpinner knows nothing about gigablox and doesnt
    // need to as it is just added complexity to the data class so the renderer needs to infer it from the data.
    updateClipRects(recalcBlockData = true) {
      const bonusID = resourceManager.getConfiguration().symbols['Bonus'].ID;
      let symbolData = this._reelSpinnerData.getSymbolData(); // symbols that need to be drawn
      if (recalcBlockData) {
        this._blockData = this.calcBlockData();
      }

      const preSymbolIndex = Globals.NUM_ROWS + Globals.NUM_PRE_APPERATURE_SYMBOLS - 1;
      if (symbolData[preSymbolIndex].symId === bonusID) {
        // bonus symbol just above
        this._blockData[preSymbolIndex] = 0; // give valid blockData so it renders the pre symbol
      }
      const postSymbolIndex = Globals.NUM_ROWS + Globals.NUM_PRE_APPERATURE_SYMBOLS;
      if (symbolData[postSymbolIndex].symId === bonusID) {
        // bonus symbol just above
        this._blockData[postSymbolIndex] = 0; // give valid blockData so it renders the post symbol
      }

      //   let symbolHeight = this._reelSpinnerData._minSymbolSpacing; // height of a 1x1 symbol
      for (let i = 0; i < symbolData.length; ++i) {
        let imageSize = this._symbolSizes[symbolData[i].symId]; // size of the sprite (the actual gigablox size)
        const blockSize = symbolData[i].symId === bonusID ? 1 : this._blockSize;
        let symbolHeight = imageSize.y / blockSize; // height of a 1x1 symbol, cant use minSymbolSpacing due to symbols with bigger texture  heights (see 6x6 bonus symbol on hunters moon)
        let blockOffset = symbolHeight * this._blockData[i]; // height of this symbol based on the size of the gigablox

        let scale = this._symbolGfxObjects[i].scale;
        this._symbolGfxObjects[i].symbol.mask.clear();
        this._symbolGfxObjects[i].symbol.mask.beginFill(0x000000, 0);
        let left = 0;
        let top = blockOffset / scale.y + this._symbolOffset[symbolData[i].symId].y;
        let width = imageSize.x / scale.x;
        let height = imageSize.y / scale.y / blockSize + 1 - this._symbolOffset[symbolData[i].symId].y; // + 1 because we need to make the clip rect 1 pixel high otherwise on none native aspect ratios you can get a pixel slice between the symbols
        this._symbolGfxObjects[i].symbol.mask.drawRect(left, top, width, height);
        this._symbolGfxObjects[i].symbol.mask.endFill();
      }
    }

    forceSymbolsTo(symbols) {
      const symbolData = this._reelSpinnerData.getSymbolData();
      for (let i = 0; i < symbolData.length; i++) {
        if (typeof symbols[i] === 'number') {
          symbolData[i].symId = symbols[i];
        }
      }
    }

    calcBlockData() {
      let blockInfo = [];
      let reelId = this._reelIndex;
      if (this._reelSpinnerData._reelSpinning) {
        blockInfo = this._gigabloxFactory.analyseBlocksOnReel(
          this._slotMachine.getSymbolsOnReel(reelId),
          this._blockSize,
          reelId
        );
      } else {
        blockInfo = this._gigabloxFactory.getReelBlockInfo(reelId);
      }

      // this._slotMachine.getSymbolsOnReel(1) = [4,3,3,8,8,6,6,4,4,4,1,1]
      // block size = 2
      // startingReelId = 1
      // blockInfo '[
      //   {"row":0,"count":1,"symId":4,"blockSize":2,"startingGlobalReelId":1,"offset":1},
      //   {"row":1,"count":2,"symId":3,"blockSize":2,"startingGlobalReelId":1,"offset":0},
      //   {"row":3,"count":2,"symId":8,"blockSize":2,"startingGlobalReelId":1,"offset":0},
      //   {"row":5,"count":2,"symId":6,"blockSize":2,"startingGlobalReelId":1,"offset":0},
      //   {"row":7,"count":2,"symId":4,"blockSize":2,"startingGlobalReelId":1,"offset":0},
      //   {"row":9,"count":1,"symId":4,"blockSize":2,"startingGlobalReelId":1,"offset":0},
      //   {"row":10,"count":2,"symId":1,"blockSize":2,"startingGlobalReelId":1,"offset":0}
      // ]'
      // which ultimately results in
      // res = [0,1,0,1,0,1,1] but we need the same amount as this._slotMachine.getSymbolsOnReel(2)!!!!
      // ideally we should have [1,0,1,0,1,0,1,0,1,0,0,1]
      // so 0 is top, 1 is bottom
      // or 0 is top, 1 is middle and 2 is bottom
      // THIS IS NOW WORKING AS EXPECTED!!!

      let res = [];

      if (!blockInfo) {
        if (this._reelSpinnerData._reelSpinning) {
          blockInfo = this._gigabloxFactory.analyseBlocksOnReel(
            this._slotMachine.getSymbolsOnReel(reelId),
            this._blockSize,
            reelId
          );
        } else {
          blockInfo = this._gigabloxFactory.getReelBlockInfo(reelId);
        }
      }

      // THIS IS NOW WORKING AS EXPECTED!!!
      for (let i = 0; i < blockInfo.length; ++i) {
        let block = blockInfo[i];
        let numToDraw = block.count;
        let startOffset = block.offset;
        for (let j = 0; j < numToDraw; ++j) {
          res.push(startOffset + j);
        }
      }

      // WE DO NOW GET [1,0,1,0,1,0,1,0,1,0,0,1] FROM THE ABOVE EXAMPLE DATA
      return res;
    }

    updateSymbolPositions(positions) {
      if (this._reelSpinnerData._reelSpinning) {
        this.wasSpinningBefore = true;
      } else {
        if (this.wasSpinningBefore) {
          this.hitAreasRequired = true;
          this.wasSpinningBefore = false;
        }
      }

      let symbolHeight = this._reelSpinnerData._minSymbolSpacing;
      for (let i = 0; i < positions.length; ++i) {
        let pos = positions[i];
        let yPos = pos.y;
        if (this._blockSize > 1) {
          let blockOffset = symbolHeight * (typeof this._blockData[i] === 'number' ? this._blockData[i] : 0);
          //SPA 20/11/23 +1 remove the +1 offset to fix large symbols not fitting quite right ( 1 pixel off at bottom of reels )
          // + 1 because we need to make the clip rect 1 pixel high otherwise on none native aspect ratios you can get a pixel slice between the symbols
          yPos -= blockOffset;
        }

        this._symbolGfxObjects[i].position.setX(pos.x);
        this._symbolGfxObjects[i].position.setY(yPos);

        if (!this._reelSpinnerData._reelSpinning && this.hitAreasRequired) {
          if (i < Globals.NUM_ROWS) {
            // this.bonusSymbolPolyData

            let symbolData = this._reelSpinnerData.getSymbolData();
            const symbol = this._symbolGfxObjects[i].symbol;
            const symId = symbolData[i].symId;
            const offset = this._symbolOffset[symId];
            if (symId === 11) {
              const poly = new PIXI.Polygon(this.bonusSymbolPolyData[this._blockSize]);
              poly.x = offset.x * -1;
              poly.y = 0;
              symbol.hitArea = poly;

              // if (symbol.hitAreaDebug) {
              //   symbol.removeChild(symbol.hitAreaDebug);
              //   symbol.hitAreaDebug = null;
              // }

              // const graphic = new PIXI.Graphics();
              // graphic.beginFill(0x00ff00);
              // graphic.lineStyle(4, 0x00ff00, 1);
              // graphic.drawPolygon(this.bonusSymbolPolyData[this._blockSize]);
              // graphic.endFill();
              // graphic.alpha = 0.5;
              // symbol.addChild(graphic);
              // symbol.hitAreaDebug = graphic;
            } else {
              const rect = new PIXI.Rectangle(
                offset.x * -1,
                offset.y * 1 * -1,
                126 * this._blockSize,
                126 * this._blockSize
              );
              symbol.hitArea = rect;
              // if (symbol.hitAreaDebug) {
              //   symbol.removeChild(symbol.hitAreaDebug);
              //   symbol.hitAreaDebug = null;
              // }
              // const graphic = new PIXI.Graphics();
              // graphic.position.set(offset.x * -1, offset.y * 1 * -1);
              // symbol.addChild(graphic);
              // symbol.hitAreaDebug = graphic;
              // graphic.lineStyle(5, 0x00ff00, 0.5);
              // graphic.drawRect(0, 0, 126 * this._blockSize, 126 * this._blockSize);
            }
          }
        }
      }
      this.hitAreasRequired = false;
    }

    updateClipRect(y, height) {
      this._clipRect.height = height;
      this._clipRect.y = y;

      this.mask.clear();
      this.mask.beginFill(0, 0);
      this.mask.drawRect(this._clipRect.x, this._clipRect.y, this._clipRect.width, this._clipRect.height);
      this.mask.endFill();
    }

    recalculateBlockData() {
      this._blockData = this.calcBlockData();
      return this._blockData;
    }

    popSymbols(popData, callback, injectNew, preCompiledInjectList) {
      const popSymbolsData = this._reelSpinnerData.popSymbols(popData, callback, injectNew, preCompiledInjectList);
      // this.redraw();
      return popSymbolsData;
    }

    dropSymbols(dropData, completeCallback) {
      this._reelSpinnerData.dropSymbols(dropData, completeCallback);
    }

    getSymbolData() {
      return this._reelSpinnerData.getSymbolData();
    }

    getSymbolsInView() {
      return this._reelSpinnerData.getSymbolsInView();
    }

    setReelSymbol(row, symbolID) {
      const adjustedRow = this._reelSpinnerData.setReelSymbol(row, symbolID);
      const symbolData = this.getSymbolData();
      const ids = [];
      for (let i = 0; i < symbolData.length; ++i) {
        ids.push(symbolData[i].symId);
      }
      this.updateSymbolIds(ids);
      this.scaleIndexToImageSize(adjustedRow);
      if (this._blockSize > 1) {
        this.updateClipRects();
      }

      // need to update the sprite used and the clip rects etc
    }

    getSymbolGfx() {
      return this._symbolGfxObjects;
    }
  }

  function createGigablox(json) {
    let sm = resourceManager.getController(json.slotMachineName);
    let gigabloxFactory = resourceManager.get('slotContainer:GigabloxFactory');
    return new ReelSpinnerVisualGigablox(
      json.ID,
      json.ID + ' container',
      json.appertureHeight,
      sm,
      json.minSymbolSpacing,
      json.blockSize,
      gigabloxFactory,
      json.reelIndex
    );
  }

  function initialseGigablox(json, reelSpinnerVisual) {
    reelSpinnerVisual.initialise(json);
    if (json.blockSize > 1) {
      for (let i = 0; i < reelSpinnerVisual._symbolGfxObjects.length; ++i) {
        reelSpinnerVisual._symbolGfxObjects[i].symbol.mask = new PIXI.Graphics();
        reelSpinnerVisual._symbolGfxObjects[i].symbol.mask.beginFill(0x000000, 0);
        reelSpinnerVisual._symbolGfxObjects[i].symbol.mask.drawRect(0, 0, 0, 0);
        reelSpinnerVisual._symbolGfxObjects[i].symbol.mask.endFill();
        reelSpinnerVisual._symbolGfxObjects[i].symbol.addChild(reelSpinnerVisual._symbolGfxObjects[i].symbol.mask);
      }
    }

    for (let i = 0; i < 5; ++i) {
      // lets add a hit area to each symbol gfx
      const symbol = reelSpinnerVisual._symbolGfxObjects[i].symbol;
      symbol.buttonMode = false;
      symbol.interactive = true;
      symbol.mousedown = symbol.touchstart = () => {
        if (reelSpinnerVisual.canClickASymbol && !autoplayManager.isAutoplayEnabled()) {
          reelSpinnerVisual.onSymbolTouched(reelSpinnerVisual._symbolGfxObjects[i], i);
        }
      };
    }
  }

  function getRequiredFilesGigablox() {
    return [];
  }

  resourceManager.registerObjectType(
    'ReelSpinnerVisualGigablox',
    createGigablox,
    initialseGigablox,
    getRequiredFilesGigablox
  );
})();
